import { call, takeEvery } from 'redux-saga/effects';

import {
  TRACK_DOWNLOAD_DIALOG_SHOWN,
  TRACK_DOWNLOAD_DIALOG_GO_TO_WORKSPACE,
  TRACK_DOWNLOAD_DIALOG_CONTINUE_EDITING
} from 'js/actionCreators/trackingActions';

import { track } from '../mixpanelProvider';

function* trackDownloadDialogShown() {
  yield call(track, 'Download Dialog Shown');
}
function* trackDownloadDialogGoToWorkspace() {
  yield call(track, 'Download Dialog - Go To Workspace');
}
function* trackDownloadDialogContinueEditing() {
  yield call(track, 'Download Dialog - Continue Editing');
}

export default function* trackDownloadModalSagas() {
  yield takeEvery(TRACK_DOWNLOAD_DIALOG_SHOWN, trackDownloadDialogShown);
  yield takeEvery(TRACK_DOWNLOAD_DIALOG_GO_TO_WORKSPACE, trackDownloadDialogGoToWorkspace);
  yield takeEvery(TRACK_DOWNLOAD_DIALOG_CONTINUE_EDITING, trackDownloadDialogContinueEditing);
}
